/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Shot_Source_Detect_AutoInputs */

const en_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detect Automatically`)
};

const fr_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection automatique`)
};

const de_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Erkennung`)
};

const it_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento automatico`)
};

const ru_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение автоматически`)
};

const es_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar automáticamente`)
};

const zh_cn2_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动检测`)
};

const ja_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動検出`)
};

const hi_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित रूप से पता लगाएं`)
};

const pt_pt2_ad_shot_source_detect_auto = /** @type {(inputs: Ad_Shot_Source_Detect_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectar automaticamente`)
};

/**
* | output |
* | --- |
* | "Detect Automatically" |
*
* @param {Ad_Shot_Source_Detect_AutoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_shot_source_detect_auto = /** @type {((inputs?: Ad_Shot_Source_Detect_AutoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Shot_Source_Detect_AutoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_shot_source_detect_auto(inputs)
	if (locale === "de") return de_ad_shot_source_detect_auto(inputs)
	if (locale === "it") return it_ad_shot_source_detect_auto(inputs)
	if (locale === "ru") return ru_ad_shot_source_detect_auto(inputs)
	if (locale === "es") return es_ad_shot_source_detect_auto(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_shot_source_detect_auto(inputs)
	if (locale === "ja") return ja_ad_shot_source_detect_auto(inputs)
	if (locale === "hi") return hi_ad_shot_source_detect_auto(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_shot_source_detect_auto(inputs)
	return en_ad_shot_source_detect_auto(inputs)
});